import { render, staticRenderFns } from "./BtCombolist.vue?vue&type=template&id=59ace870&"
import script from "./BtCombolist.vue?vue&type=script&lang=js&"
export * from "./BtCombolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports